import { Link } from "react-router-dom";
import { SOURCES } from "@/lib/sources";

export const Cite = ({ refs = [] }) => {
  const items = refs.map((k) => [k, SOURCES[k]]).filter(([, s]) => s);
  if (!items.length) return null;
  return (
    <span className="ml-1 whitespace-normal font-mono text-[12px] text-[#98bfa2]" data-testid={`cite-${refs.join("-")}`}>
      (
      {items.map(([k, s], i) => (
        <span key={k}>
          {i > 0 && "; "}
          <Link to={`/fonti#${k}`} title={s.full} className="underline decoration-dotted underline-offset-2 hover:text-[#c4dcca]">{s.short}</Link>
        </span>
      ))}
      )
    </span>
  );
};
